@if (!!passwordControl().errors && (focused() || passwordControl().touched))
{
    <div class="d-flex flex-column gap-2 validation-rules">
        @if (passwordControl().errors?.required || passwordControl().errors?.minlength)
        {
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/check-circle.svg" [svgStyle]="{'width.px': 16, 'height.px': 16}" />
                <p class="body12 password-validation">{{ 'AUTH.FIELD_ERRORS.PASSWORD_CHARACTERS' | translate }}</p>
            </div>
        }
        @if (passwordControl().errors?.lettersAndNumbers)
        {
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/check-circle.svg" [svgStyle]="{'width.px': 16, 'height.px': 16}" />
                <p class="body12 password-validation">{{ 'AUTH.FIELD_ERRORS.PASSWORD_LETTERS_NUMBERS' | translate }}</p>
            </div>
        }
        @if (passwordControl().errors?.capitalLetter)
        {
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/check-circle.svg" [svgStyle]="{'width.px': 16, 'height.px': 16}" />
                <p class="body12 password-validation">{{ 'AUTH.FIELD_ERRORS.PASSWORD_ONE_CAPITAL_LETTER' | translate }}</p>
            </div>
        }
        @if (passwordControl().errors?.lowerCaseLetter)
        {
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/check-circle.svg" [svgStyle]="{'width.px': 16, 'height.px': 16}" />
                <p class="body12 password-validation">{{ 'AUTH.FIELD_ERRORS.PASSWORD_ONE_LOWER_CASE_LETTER' | translate }}</p>
            </div>
        }
        @if (passwordControl().errors?.specialCharacter)
        {
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/check-circle.svg" [svgStyle]="{'width.px': 16, 'height.px': 16}" />
                <p class="body12 password-validation">{{ 'AUTH.FIELD_ERRORS.PASSWORD_SPECIAL_CHARACTER' | translate }}</p>
            </div>
        }
    </div>
}
